<template>
  <div id="bg">
    <div class="login-page">
      <div class="form">
        <div class="text-center">
          <img src="../../assets/logo_blue.png" alt="SnowEats Logo" />
        </div>
        <form class="login-form">
          <input v-model="username" type="text" placeholder="Cuenta de usuario" />
          <input v-model="password" type="password" placeholder="Clave" />
          <button :disabled="inRequest" @click.prevent="makeLogin" class="btn main-blue-bg">
            <div v-if="!inRequest">Entrar</div>
            <div v-else class="loader">
              <div class="spinner"></div>
            </div>
          </button>
          <br />
          <div class="alert alert-danger text-left" v-show="error.length > 0">{{ error }}</div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import router from "../../router.js";
import { UserService } from '../../services/UserService.js';

export default {
  name: "Login",
  data: function () {
    return {
      username: "",
      password: "",
      db: firebase.firestore(),
      inRequest: false,
      error: "",
      role: 0,
      userService: new UserService()
    };
  },
  methods: {
    makeLogin: async function () {
      if (this.username == "" || this.password == "") {
        return false;
      }
      this.error = '';
      this.inRequest = true;
      try {
        const authResult = await firebase
          .auth()
          .signInWithEmailAndPassword(this.username, this.password);

        const userMetadata = await this.getUserMetadata(authResult.user.email);
        
        this.$store.commit("setUserName", userMetadata.name);
        this.$store.commit("setUserId", authResult.user.email);
        this.$store.commit("setRole", userMetadata.role);
        this.$store.commit("setUser", userMetadata);

        if (userMetadata.role === this.$constants.userRoles.COMERCE) {
          this.$store.commit("setUserCompany", userMetadata.company);
        }

        this.userService.saveLoginLog( authResult.user.email )
        .then();

        this.$emit("logged");
        router.push("/orders");

      } catch (e) {
        this.manageError(e);
      }
      this.inRequest = false;
    },
    async getUserMetadata(email) {
      const ref = await this.db.collection("User").doc(firebase.auth().currentUser.uid).get()
      return ref.data();
    },
    async getUserPermissions(companyId, user) {
      const ref = await this.db
        .collection("Company")
        .doc(companyId)
        .collection("UserPermission")
        .doc(user)
        .get();
      let permissions = null;
      try {
        permissions = ref.data().permission;
      } catch (e) {
        permissions = {};
      }
      return Promise.resolve(permissions);
    },
    manageError: function (error) {
      console.log('manageError ',error);
      switch (error.code) {
        case "company-inactive":
          this.error = error.message;
          break;
        case "blocked-user":
          this.error = error.message;
          break;
        case "auth/network-request-failed":
          this.error = "Error de conexion, revisa tu conexion a internet";
          break;
        case "auth/wrong-password":
          this.error = "Usuario o clave incorrecta";
          break;
        case "auth/user-not-found":
          this.error = "El usuario no existe, verifique que este bien escrito";
          break;
        default:
          this.error = error.message; 
          break;
      }
    },
  },

  mounted: function () {
    firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import url(https://fonts.googleapis.com/css?family=Roboto:300);
img {
  height: 130px;
  width: auto;
  margin-bottom: 40px;
  margin-top: 20px;
}
#bg {
  background-image: url("../../assets/bg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
}
.login-page {
  width: 360px;
  padding: 8% 0 0;
  margin: 0 auto;
}
.form {
  border-radius: 10px;
  position: relative;
  z-index: 1;
  background: #ffffff;
  max-width: inherit;
  margin: 0 auto 40px;
  padding: 45px;
  text-align: center;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
}
.form input {
  font-family: "Roboto", sans-serif;
  outline: 0;
  background: #f2f2f2;
  width: 100%;
  border: 0;
  margin: 0 0 15px;
  padding: 15px;
  box-sizing: border-box;
  font-size: 14px;
}
.form button {
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
  outline: 0;
  background: #4caf50;
  width: 100%;
  border: 0;
  padding: 15px;
  color: #ffffff;
  font-size: 14px;
  -webkit-transition: all 0.3 ease;
  transition: all 0.3 ease;
  cursor: pointer;
}
.form button:hover,
.form button:active,
.form button:focus {
  background: #43a047;
}
.form .message {
  margin: 15px 0 0;
  color: #b3b3b3;
  font-size: 12px;
}
.form .message a {
  color: #4caf50;
  text-decoration: none;
}
.form .register-form {
  display: none;
}
.loader {
  display: flex;
  height: 20px;
  justify-content: center;
  align-items: center;
}
.spinner {
  height: 20px;
  width: 20px;
  border: 6px solid rgba(0, 0, 0, 0.2);
  border-top-color: rgba(0, 0, 0, 0.8);
  border-radius: 100%;
  animation: rotation 0.6s infinite linear 0.25s;

  /* the opacity is used to lazyload the spinner, see animation delay */
  /* this avoid the spinner to be displayed when visible for a very short period of time */
  opacity: 0;
}
@keyframes rotation {
  from {
    opacity: 1;
    transform: rotate(0deg);
  }
  to {
    opacity: 1;
    transform: rotate(359deg);
  }
}
.err-message {
  color: red;
  font-weight: 700;
}
.app-title {
  font-size: 2rem;
  color: dodgerblue;
  font-weight: bold;
}
@media screen and (max-width: 500px){
  .login-page {
    width: 300px;
    padding-top: 100px;
  }
  .form{
    padding: 29px;
  }
}
</style>
